class SearchForm {
    MODE_EASY_ROUTE = 'easy-route';
    MODE_DIFFICULT_ROUTE = 'difficult-route';
    class = {
        error: 'error',
        form_item: 'js-form-item',
        form_valid_error: 'js-form-valid-error',
        input_tag: 'js-input',
        input_passenger_count: 'js-passengers-count-input',
        input_passenger_count_tablet: 'js-passengers-count-input-tablet',
        input_passengers_wrapper: 'js-passengers-count-wrapper',
        input_departure: 'js-departure',
        input_arrival: 'js-arrival',
        input_date_forth: 'js-date-forth',
        input_date_back: 'js-date-back',
        field_value: 'js-field-value',
        auto_switch: 'js-auto-switch',
        open_minimize: 'open-minimize',
    };
    custom_events = {
        subsidy_switch_change: 'subsidy_change',
        open_passengers_picker: 'open_passengers',
        directions_change: 'direction_change',
        passengers_change: 'passengers-change'
    };

    constructor(options) {
        var that = this;

        // DOM
        that.$wrapper = options['$wrapper'];

        that.$easy_route_wrapper = that.$wrapper.find('.js-easy-route-wrapper');
        that.$easy_mode_departure_input = that.$easy_route_wrapper.find('.' + that.class.input_departure);
        that.$easy_mode_arrival_input = that.$easy_route_wrapper.find('.' + that.class.input_arrival);
        that.$easy_mode_swap_direction = that.$easy_route_wrapper.find('.js-swap-direction');

        that.$easy_mode_date_forth_input = that.$easy_route_wrapper.find('.' + that.class.input_date_forth);
        that.$easy_mode_date_back_input = that.$easy_route_wrapper.find('.' + that.class.input_date_back);
        that.$clear_date_back = that.$easy_route_wrapper.find('.js-clear-date-back');

        that.$easy_mode_submit_button = that.$easy_route_wrapper.find('.js-submit');
        that.$easy_mode_passengers_count_input = that.$easy_route_wrapper.find('.' + that.class.input_passenger_count);
        that.$easy_mode_passengers_picker = that.$easy_route_wrapper.find('.js-passenger-categories-picker');
        that.$easy_mode_passengers_count_wrapper = that.$easy_route_wrapper.find('.' + that.class.input_passengers_wrapper);

        that.$difficult_route_wrapper = that.$wrapper.find('.js-difficult-route-wrapper');
        that.$arrival_select_options = that.$wrapper.find('.js-arrival-select-options .js-option');
        that.$open_hotels = that.$wrapper.find('.js-open-hotels');

        // DOM minimized form
        that.$easy_route_mini_wrapper = that.$wrapper.find('.js-easy-route-mini-wrapper');
        that.$easy_mode_mini_departure_input = that.$easy_route_mini_wrapper.find('.' + that.class.input_departure);
        that.$easy_mode_mini_arrival_input = that.$easy_route_mini_wrapper.find('.' + that.class.input_arrival);
        that.$easy_mode_mini_date_forth_input = that.$easy_route_mini_wrapper.find('.' + that.class.input_date_forth);
        that.$easy_mode_mini_date_back_input = that.$easy_route_mini_wrapper.find('.' + that.class.input_date_back);
        that.$easy_mode_mini_passengers_count_input = that.$easy_route_mini_wrapper.find('.' + that.class.input_passenger_count);
        that.$easy_mode_mini_passengers_count_input_tablet = that.$easy_route_mini_wrapper.find('.' + that.class.input_passenger_count_tablet);

        // CONST
        that.subsidized_routes = options['subsidized_routes'];
        that.with_hotels = options['with_hotels'];
        that.ostrovok_data = options['ostrovok_data'] || null;
        that.minimize_form = options['minimize_form'] || false;

        that.templates = options['templates'];
        that.locales = options['locales'];
        that.plural = options['plural'];

        // DYNAMIC VARS
        that.mode = that.MODE_EASY_ROUTE;
        that.calendar_data = null;
        /**
         * Labels for which direction were successfully set the last:
         * - 0 is forth direction
         * - 1 is back direction
         * @type {Integer|null}
         */
        that.calendar_direction = null;
        // current request data; if request is not currently sending, it is `null`
        that.calendar_request = null;

        that.ui_calendar_input = null;

        that.passengers_picker = null;
        that.passengers_picker_mobile = null;
        
        that.passengers_count_picker_shown = false;
        that.debounce_timer = null;
        that.is_changed = false;
        // Данные для revert
        that.default_form_data = null;

        // Watcher
        that.changes_watcher = that.#initChangesWatcher(options['blur_on_change']);
        that.autofocus_manager = null;

        // INIT
        that.init();
    }

    init() {
        var that = this;

        that.initEasyRoute();
        //
        that.initMinimizedForm();
        // Инициализируем модуль автофокуса после того, как тригернутся все события в initEasyRoute
        that.autofocus_manager = that.#initAutoFocusManager();
        //
        that.initDateInputs();
        //
        that.initSubmit();
        //
        that.__initInputsClearError();

        // Собираем данные в самом конце инициализации
        that.default_form_data = that.#getFormData();
    }

    initEasyRoute() {
        var that = this;

        that.$easy_mode_departure_input.on('change', onDepartureInputChange);

        // sync arrival -> departure destinations (if departure was empty)
        that.$easy_mode_arrival_input.on('change', function () {
            if (!!that.$easy_mode_departure_input.val()) {
                return;
            }
            
            var $input = $(this),
                arrival_code = $input.val(),
                $select = that.$easy_mode_departure_input.parents('.select').first();
            
            $select.find('.select-options .option').not('.option-empty').each(function () {
                var $option = $(this),
                    data_to = $option.data('to'),
                    is_hidden = arrival_code && (data_to.indexOf(arrival_code) === -1);

                if (!!arrival_code) {
                    $option.data('hidden', is_hidden);
                    if (is_hidden) {
                        $option.hide();
                    } else {
                        $option.show();
                    }
                } else {
                    $option.data('hidden', false);
                    $option.show();
                }
            });
        });

        that.$easy_mode_arrival_input.on('change', swap_available);
        that.$easy_mode_departure_input.on('change', swap_available);

        onDepartureInputChange();
        swap_available();

        that.$easy_mode_swap_direction.on('click', function () {
            var allowed = !that.$easy_mode_swap_direction.attr('disabled');

            if (allowed) {
                var departure_code = that.$easy_mode_departure_input.val(),
                    arrival_code = that.$easy_mode_arrival_input.val();

                that.$easy_mode_departure_input.val('');
                that.$easy_mode_arrival_input.val('');

                setTimeout(function () {
                    that.$easy_mode_departure_input.val(arrival_code).trigger('change');
                    that.$easy_mode_arrival_input.val(departure_code).trigger('change');
                    // TODO фокус на поле $arrival_input = that.$easy_mode_arrival_input.parents('.select').first().find('input[type=text]')
                }, 0);
            }
        });

        // Init passenger categories form
        that.__initPassengerCategories(false);
        that.$easy_mode_passengers_count_input.on('focus', function (e) {
            e.preventDefault();
            
            that.passengers_count_picker_shown = true;
            
            // init passenger categories
            if ($.sa.is_mobile() || $.sa.is_tablet()) {
                var $input = $(this);
                $input.prop('disabled', true); // Huck for disable keyboard in mobiles
                setTimeout(function () {
                    $input.prop('disabled', false);
                    that.__initPassengerCategories(true);
                }, 100);
            }
        });

        // set start passengers count value
        that.__displayPassengerCategoriesCount(that.passengers_picker.count());

        var change_subsidy = function () {
            var arrival_code = that.$easy_mode_arrival_input.val(),
                departure_code = that.$easy_mode_departure_input.val();

            if (arrival_code && departure_code) {
                that.passengers_picker.setSubsidyHas(
                    that.__isRouteSubsidized(departure_code, arrival_code)
                );
            }
        };
        that.$easy_mode_arrival_input.on('change', change_subsidy);
        that.$easy_mode_departure_input.on('change', change_subsidy);

        that.__initCustomEvents();

        var timer = null,
            _updateCalendarDays = function () {
                // timer to debounce directions swap
                timer && clearTimeout(timer);
                timer = setTimeout(function () {

                    that.updateCalendar();
    
                    if (true === that.__isCalendarInited()) {
                        // Scroll to the first active or selected day
                        var $day_to_scroll = that.ui_calendar_input.ui_calendar.getFirstSelectedDay();
                        if (!$day_to_scroll.length) {
                            $day_to_scroll = that.ui_calendar_input.ui_calendar.getFirstActiveDay();
                        }
                        if ($day_to_scroll.length) {
                            that.ui_calendar_input.ui_calendar.scrollToDay($day_to_scroll);
                        }
                    }
                }, 10);
            };
        that.$easy_mode_arrival_input.on('change', _updateCalendarDays);
        that.$easy_mode_departure_input.on('change', _updateCalendarDays);

        function onDepartureInputChange() {
            var $input = that.$easy_mode_departure_input,
                departure_code = $input.val(),
                selected_arrival_code = that.$easy_mode_arrival_input.val(),
                arrival_code_available = false,
                $select_departure = $input.parents('.select').first(),
                $select_arrival = that.$easy_mode_arrival_input.parents('.select').first(),
                $arrival_input = $select_arrival.find('input[type=text]');

            // sync departure -> arrival destinations
            $select_arrival.find('.select-options .option').not('.option-empty').each(function () {
                var $option = $(this),
                    from = $option.data('from'),
                    arrival_code = $option.data('value'),
                    is_hidden = departure_code && (from.indexOf(departure_code) === -1);

                $option.data('hidden', is_hidden);
                if (is_hidden) {
                    $option.hide();
                } else {
                    if (arrival_code === selected_arrival_code) {
                        arrival_code_available = true;
                    }
                    $option.show();
                }
            });

            if (!arrival_code_available) {
                $arrival_input.val('');
                that.$easy_mode_arrival_input.val('').trigger('change');
            }

            // show all departure destinations if it was sync with arrival (if departure was empty)
            $select_departure.find('.select-options .option').not('.option-empty').each(function () {
                var $option = $(this);

                $option.data('hidden', false);
                $option.show();
            });
        }

        function swap_available() {
            var arrival_code = that.$easy_mode_arrival_input.val(),
                departure_code = that.$easy_mode_departure_input.val(),
                $select = that.$easy_mode_arrival_input.parents('.select').first(),
                $selected = $select.find('.select-options .option[data-value="' + arrival_code + '"]').first(),
                to = ($selected.data('to') || []),
                swap_available = departure_code && arrival_code && (to.indexOf(departure_code) !== -1);
            // some glitches at select, so swap available only on filled fields

            that.$easy_mode_swap_direction.prop('disabled', !swap_available);

            that.$wrapper.trigger(that.custom_events.directions_change, [{subsidized: that.__isRouteSubsidized(departure_code, arrival_code)}]);
        }
    }

    initMinimizedForm() {
        var that = this,
            separator = '—';

        if (!that.minimize_form) {
            return;
        }

        // для инициализации
        that.$easy_mode_mini_departure_input.text(that.$easy_mode_departure_input.val() || separator);
        that.$easy_mode_mini_arrival_input.text(that.$easy_mode_arrival_input.val() || separator);
        that.$easy_mode_mini_date_forth_input.text(that.$easy_mode_date_forth_input.val() || separator);
        that.$easy_mode_mini_date_back_input.text(that.$easy_mode_date_back_input.val() || separator);
        // для работы mobile/tablet вида свернутой формы на пассажирах
        that.$easy_mode_mini_passengers_count_input.text(that.$easy_mode_passengers_count_input.attr('data-value') || separator);
        that.$easy_mode_mini_passengers_count_input_tablet.text(that.$easy_mode_passengers_count_input.val() || separator)

        // разворачивание (desktop)
        that.$easy_mode_departure_input.on('change', function () {
            that.$wrapper.removeClass(that.class.open_minimize)
        });
        that.$easy_mode_arrival_input.on('change', function () {
            that.$wrapper.removeClass(that.class.open_minimize)
        });
        that.$easy_mode_date_forth_input.on('change', function () {
            that.$wrapper.removeClass(that.class.open_minimize)
        });
        that.$easy_mode_date_back_input.on('change', function () {
            that.$wrapper.removeClass(that.class.open_minimize)
        });
        that.$easy_mode_passengers_count_input.on('change', function () {
            that.$wrapper.removeClass(that.class.open_minimize)
        });

        // разворачивание (mobile/tablet)
        that.$easy_route_mini_wrapper.on('click', function () {
            that.$wrapper.removeClass(that.class.open_minimize);
        });
        that.$wrapper
            .off(that.custom_events.open_passengers_picker)
            .on(that.custom_events.open_passengers_picker, function () {
                that.$wrapper.removeClass(that.class.open_minimize);
                that.__openSubsidy();
            });

        // дополнительное форматирование
        // скрываем дату, если не выбрана
        that.$easy_mode_mini_date_forth_input.parent().toggle(
            that.$easy_mode_mini_date_forth_input.text() !== separator
        );
        that.$easy_mode_mini_date_back_input.parent().toggle(
            that.$easy_mode_mini_date_back_input.text() !== separator
        );
    }

    __openSubsidy() {
        var that = this;

        if ($.sa.is_mobile() || $.sa.is_tablet()) {
            that.$easy_mode_passengers_count_input.trigger('focus');
        } else {
            that.$easy_mode_passengers_count_input.trigger('click');
        }
        if (that.passengers_picker.isSubsidyHas() && !that.passengers_picker.isSubsidyEnabled()) {
            that.passengers_picker.setSubsidyValue(true);
            that.passengers_picker.setDefault(true);
        }
    }

    __initCustomEvents() {
        var that = this;

        if (that.minimize_form) {
            return;
        }

        // симулируем клик на выборе пассажиров при срабатывании кастомного события
        that.$wrapper
            .off(that.custom_events.open_passengers_picker)
            .on(that.custom_events.open_passengers_picker, function () {
                that.__openSubsidy();
            });
    }

    __initPassengerCategories(mobile = false) {
        var that = this,
            $input_placeholder = that.$easy_mode_passengers_count_input.siblings('.placeholder');

        var picker_options = {
                onSubsidyChange: function (value) {
                    if (that.$wrapper) {
                        that.$wrapper.trigger(that.custom_events.subsidy_switch_change, [{state: value}]);
                    }
                }
            };

        if (mobile) {
            picker_options['$wrapper'] = that.$easy_mode_passengers_picker.clone();
            picker_options.onSubmit = function(picker, data, sum) {
                updateDesktop(data);
                that.__displayPassengerCategoriesCount(sum);
                that.$wrapper.trigger(that.custom_events.passengers_change);
            };

            that.passengers_picker_mobile = UIPassengerCategoriesPicker.prototype.initMobile(
                picker_options,
                {
                    header_title: $input_placeholder.text(),
                    onOpen: function () {
                        that.$easy_mode_passengers_count_input.blur();
                    },
                    onClose: function () {
                        that.passengers_picker_mobile = null;
                    }
                }
            );
        } else {
            picker_options['$wrapper'] = that.$easy_mode_passengers_picker;
            picker_options.onChange = function (picker, category, value, sum) {
                that.__displayPassengerCategoriesCount(sum);
            };
            that.passengers_picker = new UIPassengerCategoriesPicker(picker_options);
        }

        function updateDesktop (data) {
            if (!that.passengers_picker) {
                return;
            }
            that.passengers_picker.setAll(data);
        }
    }

    __displayPassengerCategoriesCount(count) {
        var that = this;

        this.$easy_mode_passengers_count_input
            .attr('data-value', count)
            .val(count + ' ' + $.sa.localePlural(count, that.plural['passengers']))
            .change();
    }

    initDateInputs() {
        var that = this,
            focus_debounce_timeout = 3,
            // These functions are needed to save the context <that>.
            onCalendarInit = function (ui_calendar_input, ui_calendar) {
                that.updateCalendar(ui_calendar);

                // Scroll to the first active or selected day
                var $day_to_scroll = ui_calendar.getFirstSelectedDay();
                if (!$day_to_scroll.length) {
                    $day_to_scroll = ui_calendar.getFirstActiveDay();
                }
                if ($day_to_scroll.length) {
                    ui_calendar.scrollToDay($day_to_scroll);
                }
            },
            _onDateInputFocus = function (ui_calendar_input, $input, is_back_direction) {
                var direction_current = is_back_direction ? 1 : 0,
                    is_input_highlighed = ui_calendar_input.isDateInputHighlighed($input),
                    $calendar_first_selected_day,
                    $calendar_first_active_day;

                if (
                    true === is_input_highlighed &&
                    // update labels only when direction was changed
                    that.calendar_direction !== direction_current
                ) {
                    that.updateCalendar(ui_calendar_input.ui_calendar, true, is_back_direction);

                    $calendar_first_selected_day = ui_calendar_input.ui_calendar.getFirstSelectedDay();
                    // if there is no selected days, scroll to the first active day; otherwise - do not scroll
                    if (!$calendar_first_selected_day.length) {
                        $calendar_first_active_day = ui_calendar_input.ui_calendar.getFirstActiveDay();
                        if ($calendar_first_active_day.length) {
                            ui_calendar_input.ui_calendar.scrollToDay($calendar_first_active_day);
                        }
                    }

                    that.__setCalendarDirection(direction_current);
                }
            },
            onDateForthInputFocus = function (ui_calendar_input) {
                setTimeout(function () {
                    // check is input still highlighted
                    // (because highlight is bouncing between date forth input and date back input,
                    // when mouse enters the date earlier than selected forth date)
                    _onDateInputFocus(ui_calendar_input, ui_calendar_input.$date_first_input, false);
                }, focus_debounce_timeout);
            },
            onDateBackInputFocus = function (ui_calendar_input) {
                setTimeout(function () {
                    // check is input still highlighted
                    // (because highlight is bouncing between date forth input and date back input,
                    // when mouse enters the date earlier than selected forth date)
                    _onDateInputFocus(ui_calendar_input, ui_calendar_input.$date_second_input, true);
                }, focus_debounce_timeout);
            },
            onDaySelect = function (ui_calendar_input) {
                that.__clearInputError(ui_calendar_input.$date_first_input);
            },
            onCalendarFinish = function() {};

        that.ui_calendar_input = $.uiCalendarInput({
            $date_first_input: that.$easy_mode_date_forth_input,
            $date_second_input: that.$easy_mode_date_back_input,
            month_first: $.sa.server_datetime,
            month_count: 12,
            title: $.sa.locales['select_dates'],
            onCalendarInit: onCalendarInit,
            onDateFirstInputHighlight: onDateForthInputFocus,
            onDateSecondInputHighlight: onDateBackInputFocus,
            onDaySelect: onDaySelect,
            onFinish: onCalendarFinish
        });

        that.$clear_date_back.on('click', function (e) {
            e.preventDefault();
            that.ui_calendar_input.clearDateSecond();
        });
    }

    /**
     * Fetch and set data for calendar, or just set them, if they are already stored
     * @param {false|null|Object} ui_calendar Instance of UICalendar. If `false`, that.ui_calendar_input.ui_calendar would be used.
     * @param {Boolean} no_fetch If true, set stored dates only (do not send request).Even if there is no data for the direction - empty data will be passed into set labels function
     * @param {Boolean|null} is_back_direction If direction is reversed. If `null`, it would be defined in runtime.
     */
    updateCalendar(
        ui_calendar = false,
        no_fetch = false,
        is_back_direction = null
    ) {
        var that = this,
            direction_data = that.__getDirectionData(is_back_direction),
            origin = direction_data['origin'] || '',
            destination = direction_data['destination'] || '',
            rt = true;

        if (!origin || !destination) {
            return;
        }

        // if no fetch, or data for calendar is already stored -
        // ignore debounce, just apply stored data and do not send request
        if (
            no_fetch ||
            that.__hasCalendarDataFor(origin, destination)
        ) {
            that.__setCalendarDayLabels(origin, destination, ui_calendar);
            that.__setCalendarDayModifiers(origin, destination, ui_calendar);
            return;
        }

        // if request is processing, do not send another one
        if (
            that.calendar_request &&
            (
                (that.calendar_request.origin === origin && that.calendar_request.destination === destination) ||
                (that.calendar_request.rt && that.calendar_request.destination === origin && that.calendar_request.origin === destination)
            )
        ) {
            return;
        }

        // if reverse direction is already stored - fetch the only direction, which data must be shown
        if (that.__hasCalendarDataFor(destination, origin)) {
            rt = false;
        }

        var _processResponseError = function (message = '', data = null) {
            var error_text = message || 'Calendar day labels: error response.';
            $.sa.error(error_text);
            if (data) {
                $.sa.error(data);
            }
        };

        var _onDone = function (response, request_data) {
            if (that.__isResponseSuccessful(response) && that.__isResponseNotEmpty(response)) {
                var data = response.data;
                // save into component property
                that.__saveCalendarData(data);
                that.__setCalendarDirection(is_back_direction);
                // set calendar day labels, if calendar is initialized yet
                that.__setCalendarDayLabels(request_data['origin'], request_data['destination'], ui_calendar);
                that.__setCalendarDayModifiers(request_data['origin'], request_data['destination'], ui_calendar);
            } else {
                that.__saveCalendarData(null);
                that.__setCalendarDirection(null);

                if (!that.__isResponseSuccessful(response)) {
                    _processResponseError('Calendar Prices: error response.', response.errors);
                } else if (!that.__isResponseNotEmpty(response)) {
                    _processResponseError('Calendar Prices: response data is empty.')
                }
            }
        };

        var _onFail = function (jqXHR, textStatus, errorThrown) {
            that.__saveCalendarData(null);
            that.__setCalendarDirection(null);
            _processResponseError(`Calendar Prices error response: ${jqXHR.status} ${jqXHR.statusText}.`, jqXHR.responseText);
        };

        // Route Prices
        that.__requestCalendarData(origin, destination, rt, {
            onDone: _onDone,
            onFail: _onFail
        });
    }

    __saveCalendarData(calendar_data) {
        var that = this;
        if (null !== that.calendar_data && typeof that.calendar_data === 'object') {
            Object.assign(that.calendar_data, calendar_data);
        } else {
            that.calendar_data = calendar_data;
        }
    }

    __setCalendarDayLabels(origin, destination, ui_calendar = false) {
        var that = this,
            calendar_data = that.__getCalendarDataFor(origin, destination);

        // if ui_calendar is not specified, and default ui_calendar is not initialized
        if (false === ui_calendar && false === that.__isCalendarInited()) {
            return;
        }
        // if specified ui_calendar is not initialized
        if (null === ui_calendar) {
            return;
        }
        // if ui_calendar is not specified, get default ui_calendar
        if (false === ui_calendar) {
            ui_calendar = that.ui_calendar_input.ui_calendar;
        }

        ui_calendar.clearDateLabels();
        if (calendar_data) {
            ui_calendar.setDayLabels(calendar_data);
        }
    }

    __setCalendarDayModifiers(origin, destination, ui_calendar = false) {
        var that = this,
            calendar_data = that.__getCalendarDataFor(origin, destination);

        // if ui_calendar is not specified, and default ui_calendar is not initialized
        if (false === ui_calendar && false === that.__isCalendarInited()) {
            return;
        }
        // if specified ui_calendar is not initialized
        if (null === ui_calendar) {
            return;
        }
        // if ui_calendar is not specified, get default ui_calendar
        if (false === ui_calendar) {
            ui_calendar = that.ui_calendar_input.ui_calendar;
        }

        if (!calendar_data) {
            ui_calendar.clearDaysModifiers();
        } else {
            ui_calendar.updateDays(calendar_data);
        }
    }

    __getCalendarDataFor(origin, destination) {
        var that = this;

        if (false === that.__hasCalendarDataFor(origin, destination)) {
            return null;
        }
        return that.calendar_data[`${origin}-${destination}`];
    }

    __hasCalendarDataFor(origin, destination) {
        var that = this;
        if (
            null === that.calendar_data ||
            !origin.length || !destination.length
        ) {
            return false;
        }
        return that.calendar_data.hasOwnProperty(`${origin}-${destination}`);
    }

    __isCalendarInited() {
        var that = this;

        if (null === that.ui_calendar_input) {
            return false;
        }

        return null !== that.ui_calendar_input.ui_calendar;
    }

    __getDirectionData(
        back_direction = null,
        date_forth = null,
        date_back = null,
        departure_code = null,
        arrival_code = null
    ) {
        var that = this,
            $departure_input = that.$easy_mode_departure_input,
            $arrival_input = that.$easy_mode_arrival_input,
            $date_forth_input = that.$easy_mode_date_forth_input,
            $date_back_input = that.$easy_mode_date_back_input;

        if (null === departure_code) {
            departure_code = $.trim($departure_input.val());
        }
        if (null === arrival_code) {
            arrival_code = $.trim($arrival_input.val());
        }
        if (null === date_forth) {
            date_forth = $.trim($date_forth_input.data('value'));
        }
        if (null === date_back) {
            date_back = $.trim($date_back_input.data('value'));
        }
        if (null === back_direction) {
            back_direction = (!!(date_back && !date_forth) || $date_back_input.is(':focus'));
        }

        return {
            origin: back_direction ? arrival_code : departure_code,
            destination: back_direction ? departure_code : arrival_code,
            is_back_direction: back_direction
        };
    }

    /**
     * @param {Integer|null} direction
     * @private
     */
    __setCalendarDirection(direction) {
        var that = this;
        that.calendar_direction = direction;
    }

    __requestCalendarData(
        origin,
        destination,
        rt = true,
        callbacks = {}
    ) {
        if (
            !origin.length ||
            !destination.length
        ) {
            return;
        }

        var that = this,
            request_data = {
                origin: origin,
                destination: destination,
                rt: rt ? 1 : 0
            },
            onDone = (callbacks['onDone'] || function () {}),
            onFail = (callbacks['onFail'] || function () {});

        $.ajax({
            url: $.sa.build_url('search/calendar'),
            method: 'POST',
            async: true,
            data: request_data,
            dataType: 'json',
            beforeSend: function () {
                that.calendar_request = request_data;
            }
        })
        .done(function (response) {
            onDone(response, request_data);
        })
        .fail(function (jqXHR, textStatus, errorThrown) {
            onFail(jqXHR, textStatus, errorThrown);
        })
        .always(function (jqXHR) {
            that.calendar_request = null;
        });
    }

    __isResponseSuccessful(response) {
        return response && response.status === 'ok';
    }

    __isResponseNotEmpty(response) {
        return response && response.data;
    }

    __isInputsValid() {
        var that = this,
            is_valid = true,
            $input_departure = that.$easy_mode_departure_input,
            $input_arrival = that.$easy_mode_arrival_input,
            $input_forth = that.$easy_mode_date_forth_input;

        if (!that.__isInputValid($input_departure)) {
            is_valid = false;
        }
        if (!that.__isInputValid($input_arrival)) {
            is_valid = false;
        }
        if (!that.__isInputValid($input_forth)) {
            is_valid = false;
        }

        return is_valid;
    }

    __isInputValid($input) {
        var that = this,
            is_valid = !!$input.val();

        if (!is_valid) {
            that.__setInputError($input);
        }

        return is_valid;
    }

    __clearInputError($input) {
        var that = this;

        $input
            .parents('.' + that.class.form_item)
            .find('.' + that.class.form_valid_error)
            .removeClass(that.class.error);
    }

    __setInputError($input) {
        var that = this;

        $input
            .parents('.' + that.class.form_item)
            .find('.' + that.class.form_valid_error)
            .addClass(that.class.error);
    }

    __initInputsClearError() {
        var that = this,
            $input_departure = that.$easy_mode_departure_input,
            $input_arrival = that.$easy_mode_arrival_input,
            $input_forth = that.$easy_mode_date_forth_input;

        $input_departure.parents('.' + that.class.form_item).find('.' + that.class.input_tag).on('focus', function () {
            if ($.sa.is_desktop()) {
                return;
            }
            that.__clearInputError($input_departure);
        });

        $input_arrival.parents('.' + that.class.form_item).find('.' + that.class.input_tag).on('focus', function () {
            if ($.sa.is_desktop()) {
                return;
            }
            that.__clearInputError($input_arrival);
        });

        $input_forth.parents('.' + that.class.form_item).find('.' + that.class.input_tag).on('focus', function () {
            if ($.sa.is_desktop()) {
                return;
            }
            that.__clearInputError($input_forth);
        });
    }

    initSubmit() {
        var that = this,
            is_locked = false;

        that.$easy_mode_submit_button.on('click', function (e) {
            e.preventDefault();

            // Если запрос запущен, то блокируем
            if (is_locked) {
                return false;
            }

            that.autofocus_manager.focus();

            // Если форма не валидна, то блокируем
            const is_valid = that.__isInputsValid();
            if (!is_valid) {
                return false;
            }

            is_locked = true;

            that.changes_watcher.onSubmit();
            $.sa.buttonLoading(that.$easy_mode_submit_button, true);

            var search_params = that.__getSearchParams(),
                search_path = $.sa.encodeSearchPath(search_params),
                search_url = $.sa.build_url('search/' + search_path);

            $.sa.log('SearchForm: search path', search_path);
            $.sa.log('SearchForm: search url', search_url);

            if (
                that.with_hotels &&
                that.$open_hotels.is(':checked') &&
                $.sa.is_desktop() &&
                search_params.ostrovok_id &&
                search_params.passengers.values &&
                that.ostrovok_data['partner_slug'] &&
                that.ostrovok_data['partner_slug'].length
            ) {
                that.ostrovok_data['ostrovok_id'] = search_params.ostrovok_id;
                that.ostrovok_data['departure_date'] = search_params.directions[0]['date'];
                that.ostrovok_data['arrival_date'] = search_params.directions[1] ? search_params.directions[1]['date'] : null;
                that.ostrovok_data['passengers'] = search_params.passengers.values;

                window.open(search_url, '_blank');
                window.location.href = Ostrovok.prototype.getOstrovokLink(that.ostrovok_data);
                is_locked = false;
            } else {
                $.sa.content_router.load(search_url).always( function() {
                    is_locked = false;
                });
            }
        });
    }

    __getSearchParams() {
        var that = this,
            result = {
                directions: [],
                passengers: {
                    count: that.passengers_picker.count(),
                    values: that.passengers_picker.collectActiveValuesOfAllCategories()
                }
            };

        if (that.mode === that.MODE_EASY_ROUTE) {
            var departure_airport = $.trim(that.$easy_mode_departure_input.val()),
                arrival_airport = $.trim(that.$easy_mode_arrival_input.val()),
                date_forth = $.trim(that.$easy_mode_date_forth_input.data('value')),
                date_back = $.trim(that.$easy_mode_date_back_input.data('value'));

            if (departure_airport.length && arrival_airport.length && date_forth.length) {
                result.directions.push({
                    origin: departure_airport,
                    destination: arrival_airport,
                    date: date_forth,
                });

                if (date_back.length) {
                    result.directions.push({
                        origin: arrival_airport,
                        destination: departure_airport,
                        date: date_back
                    });
                }

                result['ostrovok_id'] = that.$arrival_select_options.filter('[data-value="' + arrival_airport + '"]').data('ostrovok-id');
            }
        }

        $.sa.log('SearchForm: search params', result);

        return result;
    }

    __isRouteSubsidized(departure_code, arrival_code) {
        var that = this;
        if (departure_code && that.subsidized_routes[departure_code] && Array.isArray(that.subsidized_routes[departure_code])) {
            if (arrival_code && that.subsidized_routes[departure_code].includes(arrival_code)) {
                return true;
            }
        }
        return false;
    }

    #getFormData() {
        const that = this;

        const departure  = that.$easy_mode_departure_input.val(),
              arrival    = that.$easy_mode_arrival_input.val(),
              dates = (that.ui_calendar_input ? that.ui_calendar_input.getDates() : null),
              passengers = that.passengers_picker.collect();

        return {
            departure,
            arrival,
            dates,
            passengers
        };
    }

    #setFormData(data, is_changed = true) {
        const that = this;

        if (!data.departure) {
            UISelect.prototype.__clearValue(that.$easy_mode_departure_input.closest('.select'));
        }
        that.$easy_mode_departure_input.val(data.departure).trigger('change');

        if (!data.arrival) {
            UISelect.prototype.__clearValue(that.$easy_mode_arrival_input.closest('.select'));
        }
        that.$easy_mode_arrival_input.val(data.arrival).trigger('change');

        if (data.dates) {
            that.ui_calendar_input.setDates(data.dates, true);
        }

        that.passengers_picker.setAll(data.passengers);

        that.is_changed = is_changed;
    }

    #initChangesWatcher(changes_watcher_enabled) {
        const that = this;

        /**
         * Если параметр не активен, то возвращаем пустые функции, чтобы не нагромождать условиями остальной код
         * */
        if (!changes_watcher_enabled) {
            return {
                onSubmit() {}
            };
        }

        const $body = $(document.body),
              $button = that.$easy_mode_submit_button,
              wrapper = that.$wrapper[0];

        const classes = {
            body_focus: 'with-search-form-focus',
            body_focus_remove: 'is-focus-remove',
            button_animate: 'blink'
        };

        const form_locker = getFormLocker();

        let is_locked = false,
            is_submit_start = false;

        // Events

        /**
         * Открывашка блокировки, событие при фокусе на форму
         * */
        wrapper.addEventListener('focus', function(event) {
            const lock_targets = [
                // Submit button
                that.$easy_mode_submit_button[0],
                // Mobile mini_mode button
                that.$easy_route_mini_wrapper[0]
            ];

            const use_lock = lock_targets.indexOf(event.target) < 0;
            if (use_lock) {
                lock();
            }
        }, true);

        /**
         * Слушаем изменения в форме и проставляем параметр is_changed
         * */
        that.$wrapper.on('input change', function() {
            change(true);
        });

        /**
         * Слушаем изменения в дровере (мобильный вид)
         * */
        that.$wrapper.on(['calendar-change', that.custom_events.passengers_change].join(' '), function() {
            const is_not_desktop = !$.sa.is_desktop();
            if (is_not_desktop) {
                lock();
                change(true);
            }
        });

        /**
         * Событие отмены изменений и снятие блокировки
         * */
        that.$wrapper.on('click', '.js-search-revert', function(event) {
            event.preventDefault();
            that.#setFormData(that.default_form_data, false);
            unlock();
        });

        that.$easy_mode_swap_direction.on('click', function() {
            lock();
            change(true);
        });

        return {
            onSubmit() {
                is_submit_start = true;
                unlock();
            }
        };

        // Events

        function onDocumentClick(event) {
            const is_search_form = wrapper.contains(event.target);
            if (!is_search_form && !that.is_changed) {
                unlock();
            }
        }

        function onAviaLoaded() {
            unlock();
        }

        // Functions

        function change(result = true) {
            if (!form_locker.is_active) { return false; }

            that.is_changed = result;
            form_locker.animateButton(that.is_changed);
            form_locker.tooltipToggle();
        }

        function lock() {
            if (is_submit_start) { return false; }

            if (is_locked) { return false; }
            is_locked = true;

            form_locker.lock();

            $.sa.$document.on('avia_before_load', onAviaLoaded);
            $.sa.$document.on('avia_after_load', onAviaLoaded);
            document.addEventListener('click', onDocumentClick);
        }

        function unlock() {
            if (!is_locked) { return false; }
            is_locked = false;

            $.sa.$document.off('avia_before_load', onAviaLoaded);
            $.sa.$document.off('avia_after_load', onAviaLoaded);
            document.removeEventListener('click', onDocumentClick);

            form_locker.unlock();
        }

        // Form Locker

        function getFormLocker() {
            const tooltip = getTooltip();

            const lock_hide_time = 100, 
                  animate_time = 500,
                  tooltip_toggle_time = 110;

            let lock_hide_timeout = 0,
                lock_remove_timeout = 0,
                tooltip_animate_timeout = 0,
                tooltip_toggle_timeout = 0;

            return {
                is_active: false,
                tooltip_active: false,
                lock() {
                    const self = this;

                    if (self.is_active) { return false; }
                    self.is_active = true;

                    clearTimeout(lock_hide_timeout);
                    clearTimeout(lock_remove_timeout);

                    $body
                        .removeClass(classes.body_focus_remove)
                        .addClass(classes.body_focus);

                    $.sa.scroll_locker.locked(true);
                },
                unlock() {
                    const self = this;

                    if (!self.is_active) { return false; }
                    self.is_active = false;

                    lock_hide_timeout = setTimeout( function() {
                        $body.addClass(classes.body_focus_remove);
                        self.animateButton(false);
                        self.hideTooltip();
                        $.sa.scroll_locker.unlocked(true);

                        lock_remove_timeout = setTimeout(function() {
                            $body
                                .removeClass(classes.body_focus)
                                .removeClass(classes.body_focus_remove);
                        }, animate_time);
                    }, lock_hide_time);
                },
                animateButton(animate) {
                    if (animate) {
                        $button.addClass(classes.button_animate);    
                    } else {
                        $button.removeClass(classes.button_animate);
                    }
                },
                showTooltip() {
                    const self = this;

                    const is_valid = that.__isInputsValid();
                    if (!is_valid) { return false; }

                    if (!self.is_active || self.tooltip_active) { return false; }
                    self.tooltip_active = true;

                    clearTimeout(tooltip_animate_timeout);
                    tooltip.show();
                },
                hideTooltip() {
                    const self = this;

                    if (!self.tooltip_active) { return false; }
                    self.tooltip_active = false;

                    tooltip.hide();
                    tooltip_animate_timeout = setTimeout(function() {
                        tooltip.remove();
                    }, animate_time);
                },
                tooltipToggle() {
                    const self = this;

                    if (!self.is_active) { return false; }

                    clearTimeout(tooltip_toggle_timeout);
                    tooltip_toggle_timeout = setTimeout( toggle, tooltip_toggle_time);

                    function toggle() {
                        if (that.is_changed) {
                            self.showTooltip();
                        } else {
                            self.hideTooltip();
                        }
                    }
                }
            }

            function getTooltip() {
                return {
                    $tooltip: null,
                    active_class: 'fadeInUp',
                    inactive_class: 'fadeOutDown',
                    show() {
                        const self = this;
                        if (self.$tooltip) { return false; }

                        const $tooltip = $(that.templates['submit_tooltip']).addClass('animated faster');

                        self.$tooltip = $tooltip
                            .insertAfter($button)
                            .addClass(self.active_class);

                        return $tooltip;
                    },
                    hide() {
                        const self = this;
                        if (!self.$tooltip) { return false; }

                        self.$tooltip
                            .removeClass(self.active_class)
                            .addClass(self.inactive_class);
                    },
                    remove() {
                        const self = this;
                        if (!self.$tooltip) { return false; }

                        self.$tooltip.remove();
                        self.$tooltip = null;
                    }
                }
            }
        }
    }

    #initAutoFocusManager() {
        const that = this;

        /**
         * Таймер необходим, чтобы пропустить рендер-логику разных частей формы и исключить цикл
         * Время 100мс нужно для календаря и его внутренних рендер-функций при многократном открытии/закрытии
         * */
        const focus_delay_time = 100;

        let focus_timer = 0;

        const departure_component = initDepartureComponent({
            onChange: focusOnEmptyComponent,
            onFocus: clearTimer
        });

        const arrival_component = initArrivalComponent({
            onChange: focusOnEmptyComponent,
            onFocus: clearTimer
        });

        const date_forth_component = initDateForthComponent({
            onClose: function(component) {
                if (!component.states.is_empty) {
                    focusOnEmptyComponent();    
                }
            },
            onFocus: clearTimer
        });

        const passengers_component = initPassengersComponent({
            onOpen: function(component) {
                component.states.is_empty = false;
            },
            onClose: function(component) {
                if (!component.states.is_empty) {
                    focusOnEmptyComponent();
                }
            },
            onFocus: clearTimer
        });

        // Показываем 1 раз выбор пассажиров для главной страницы
        if (location.pathname === $.sa.route_uri) {
            passengers_component.states.is_empty = true;
        }

        return {
            components: {
                departure : departure_component,
                arrival   : arrival_component,
                date_forth: date_forth_component,
                passengers: passengers_component
            },
            focus: function() {
                focusOnEmptyComponent();
            }
        };


        /**
         * Функции - инстансы компонентов
         * */

        function initDepartureComponent(options = {}) {
            const $input_hidden = that.$easy_mode_departure_input,
                  $input = $input_hidden.closest('.' + that.class.form_item).find('.' + that.class.input_tag),
                  $select = $input_hidden.closest('.select');

            const result = {
                id: 'departure',
                states: {
                    is_empty: isEmpty($input_hidden),
                    is_changed: false
                },
                focus() {
                    $input.trigger('focus');
                },
                isOpened() {
                    const $select = $input.parents('.select');
                    return UISelect.prototype.isFocused($select);
                }
            };

            if (typeof options.onOpen === 'function') {
                $select.on(UISelect.prototype.event_names.open, function() {
                    options.onOpen(result);
                });
            };

            if (typeof options.onClose === 'function') {
                $select.on(UISelect.prototype.event_names.close, function() {
                    options.onClose(result);
                });
            };

            if (typeof options.onFocus === 'function') {
                $input.on('focus', function() {
                    options.onFocus(result);
                });
            };

            $input_hidden.on('change', function() {
                result.states.is_changed = true;
                result.states.is_empty = isEmpty($input_hidden);

                if (typeof options.onChange === 'function') {
                    options.onChange(result);
                };
            });

            return result;
        }

        function initArrivalComponent(options = {}) {
            const $input_hidden = that.$easy_mode_arrival_input,
                  $input = $input_hidden.closest('.' + that.class.form_item).find('.' + that.class.input_tag),
                  $select = $input_hidden.closest('.select');

            const result = {
                id: 'arrival',
                states: {
                    is_empty: isEmpty($input_hidden),
                    is_changed: false
                },
                focus() {
                    $input.trigger('focus');
                },
                isOpened() {
                    const $select = $input.parents('.select');
                    return UISelect.prototype.isFocused($select);
                }
            };

            if (typeof options.onOpen === 'function') {
                $select.on(UISelect.prototype.event_names.open, function() {
                    options.onOpen(result);
                });
            };

            if (typeof options.onClose === 'function') {
                $select.on(UISelect.prototype.event_names.close, function() {
                    options.onClose(result);
                });
            };

            if (typeof options.onFocus === 'function') {
                $input.on('focus', function() {
                    options.onFocus(result);
                });
            };

            $input_hidden.on('change', function() {
                result.states.is_changed = true;
                result.states.is_empty = isEmpty($input_hidden);

                if (typeof options.onChange === 'function') {
                    options.onChange(result);
                };
            });

            return result;
        }

        function initDateForthComponent(options = {}) {
            const $input = that.$easy_mode_date_forth_input,
                  $wrapper = $input.closest('.calendar-input-wrapper');

            const result = {
                id: 'date_forth',
                states: {
                    is_empty: isEmpty($input),
                    is_changed: false
                },
                focus() {
                    $input.trigger('focus');
                },
                isOpened() {
                    return that.ui_calendar_input.isFocused();
                }
            };

            if (typeof options.onOpen === 'function') {
                $wrapper.on('calendar-open', function() {
                    options.onOpen(result);
                });
            };

            if (typeof options.onClose === 'function') {
                $wrapper.on('calendar-close', function() {
                    options.onClose(result);
                });
            };

            if (typeof options.onFocus === 'function') {
                $input.on('focus', function() {
                    options.onFocus(result);
                });
            };

            $input.on('calendar-change', function() {
                result.states.is_changed = true;
                result.states.is_empty = isEmpty($input);

                if (typeof options.onChange === 'function') {
                    options.onChange(result);
                };
            });

            return result;
        }

        function initPassengersComponent(options = {}) {
            const $input = that.$easy_mode_passengers_count_input,
                  $dd_wrapper = $input.closest('.dd-wrapper'),
                  $dd = $dd_wrapper.find('.dd');

            const result = {
                id: 'passengers',
                states: {
                    is_empty: false,
                    is_changed: false
                },
                focus() {
                    $input.trigger('click');
                },
                isOpened() {
                    return UIDropdown.prototype.isActive($dd);
                }
            };

            $input.on('focus', function(event) {
                if (!UIDropdown.prototype.isActive($dd)) {
                    UIDropdown.prototype.show($dd_wrapper);
                    observerToggle(true);
                }
            });

            if (typeof options.onOpen === 'function') {
                $dd_wrapper.on(UIDropdown.prototype.event_names.open, function() {
                    options.onOpen(result);
                });
            };

            if (typeof options.onClose === 'function') {
                $dd_wrapper.on(UIDropdown.prototype.event_names.close, function() {
                    options.onClose(result);
                });
            };

            if (typeof options.onFocus === 'function') {
                $input.on('focus', function() {
                    options.onFocus(result);
                });
            };

            $input.on('change', function() {
                result.states.is_empty = false;
                result.states.is_changed = true;

                if (typeof options.onChange === 'function') {
                    options.onChange(result);
                };
            });

            return result;

            /**
             * @param {Boolean} turn_on
             * */
            function observerToggle(turn_on = false) {
                if (turn_on) {
                    document.addEventListener('focus', closeOnBlur, true);
                } else {
                    document.removeEventListener('focus', closeOnBlur, true);
                }
            }

            function closeOnBlur(event) {
                var is_exist = document.contains($dd_wrapper[0]);
                if (is_exist) {
                    const is_inside = $dd_wrapper[0].contains(event.target);
                    if (!is_inside) {
                        if (UIDropdown.prototype.isActive($dd)) {
                            UIDropdown.prototype.hideCurrent($dd_wrapper);    
                        }
                        observerToggle(false);
                    }
                } else {
                    observerToggle(false);
                }
            }
        }


        /**
         * Главный метод поиска и фокуса компонента
         * */

        function focusOnEmptyComponent() {
            // Только для Desktop
            if (!$.sa.is_desktop()) { return false; }

            clearTimeout(focus_timer);
            focus_timer = setTimeout(findAndFocus, focus_delay_time);

            const components = [departure_component, arrival_component, date_forth_component, passengers_component];

            function findAndFocus() {
                // Ищем открытый компонент, и останавливаем если он есть
                const is_any_opened = isAnyOpened();
                if (is_any_opened) { return false; }

                // Ищем компонент с пустым значением
                components.some( function(component) {
                    if (component.states.is_empty) {
                        component.focus();
                        return true;
                    }
                });
            }

            function isAnyOpened() {
                let result = false;

                components.some( function(component) {
                    if (component.isOpened()) {
                        result = true;
                        return true;
                    }
                });

                return result;
            }
        }


        /**
         * Полезные функции местного значения
         * */ 

        /**
         * @param {jQuery} $input
         * @return {Boolean}
         * @description проверка наличия значения в поле
         * */
        function isEmpty($input) {
            return !$input.val();
        }

        function clearTimer() {
            clearTimeout(focus_timer);
        }
    }
}